import React, { useState } from "react";
import PropTypes from "prop-types";
import { Alert, Toggle } from "@opendate-app/setlist";
import SettingsPageWrapper from "../../../shared/SettingsPageWrapper";
import client from "../../../shared/api/client";
import { toastError, toastSuccess } from "../../../shared/toastHelper";
import "../styles/settingsSeriesDetails.css";

const checkedFrom = (value) => (value && value.target ? value.target.checked : Boolean(value));

const SettingsSeriesDetails = ({ team, canEdit, settingsPath, lastEditedAt, changelogVersions }) => {
  const [showEndTimes, setShowEndTimes] = useState(Boolean(team.series_show_end_times));
  const [saving, setSaving] = useState(false);

  const handleShowEndTimesChange = async (value) => {
    const checked = checkedFrom(value);
    const previous = showEndTimes;
    setShowEndTimes(checked);
    setSaving(true);
    try {
      await client.patch(`/teams/${team.id}`, { team: { series_show_end_times: checked } });
      toastSuccess("Setting saved.");
    } catch {
      setShowEndTimes(previous);
      toastError("Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <SettingsPageWrapper
      settingsPath={settingsPath}
      title="Series"
      lastEditedAt={lastEditedAt}
      changelogVersions={changelogVersions}
    >
      <section className="series-settings-card">
        <header className="series-settings-header">
          <h2 className="series-settings-title">Series</h2>
          <p className="series-settings-subtitle">Settings for every series your team runs.</p>
        </header>

        {!canEdit && (
          <div className="series-settings-alert">
            <Alert
              color="gray"
              title="Only account owners can change these settings"
              description="Ask an account owner on your team to change them."
            />
          </div>
        )}

        <div className="series-settings-row">
          <div className="series-settings-row-text">
            <h3 className="series-settings-row-title">Show end times</h3>
            <p className="series-settings-row-description">
              Show each date&apos;s start and end time on your series pages, like 8:00 PM – 1:00 AM, instead of only its
              start time. Each date uses the end time set on its own event.
            </p>
          </div>
          <Toggle
            id="series-show-end-times"
            label="Show end times"
            checked={showEndTimes}
            disabled={!canEdit || saving}
            onChange={handleShowEndTimesChange}
          />
        </div>
      </section>
    </SettingsPageWrapper>
  );
};

SettingsSeriesDetails.propTypes = {
  team: PropTypes.shape({ id: PropTypes.number.isRequired, series_show_end_times: PropTypes.bool }).isRequired,
  canEdit: PropTypes.bool,
  settingsPath: PropTypes.string,
  lastEditedAt: PropTypes.string,
  changelogVersions: PropTypes.array,
};

export default SettingsSeriesDetails;
